import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { Form, Input, InputNumber } from 'antd';
import { FontSizeOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {

            let containerRef = useRef(null)
            const [listField, setlistField] = useState(null)
            useEffect(() => {
                setlistField(props.pluginConfig.getListField(containerRef.current))
            }, [])

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const { data } = props

            let rules = [{ required: data.required || false, message: t`Ce champ est obligatoire` }]

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined />,
                }
            }

            var Component = Input
            var prefix = "[TEXT]_"

            let type = "text"
            switch (data.validation) {
                case formPlugin.VALIDATION[0]: // alphabet
                    type = "text"
                    rules.push({
                        pattern: new RegExp(/^[A-zÀ-ú\s]*$/),
                        message: t`Le champ doit contenir uniquement des lettres`
                    })
                    break;
                case formPlugin.VALIDATION[1]: // alphanum
                    type = "text"
                    rules.push({
                        pattern: new RegExp(/^[A-z0-9À-ú\s]*$/),
                        message: t`Le champ doit contenir uniquement des chiffres et lettres`
                    })
                    break;
                case formPlugin.VALIDATION[2]: // num
                    type = "text"
                    prefix = "[NUMBER]_"
                    Component = InputNumber
                    break;
                case formPlugin.VALIDATION[3]: // tel
                    type = "tel"
                    break;
                case formPlugin.VALIDATION[4]: // email
                    type = "email"
                    rules.push({
                        type: "email",
                        message: t`L'adresse email n'est pas valide`
                    })
                    break;
                case formPlugin.VALIDATION[5]: // url
                    type = "url"
                    break;
            }

            const listFieldProps = listField ? listField : null
            const finalName = prefix + data.fieldKey

            return (
                <div ref={(ref) => containerRef.current = ref}>
                    <Form.Item
                        {...listFieldProps}
                        label={<Trans>{(data.label || "Question")} :</Trans>}
                        name={listField ? [listField.name, finalName].flat() : finalName}
                        rules={rules}
                        tooltip={tooltip}
                    >
                        <Component type={type} placeholder={data.placeholder} style={{ width: "100%" }} min={0} />
                    </Form.Item>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-plain-text' + namespace,
        title: t`Champ court`,
        description: t`Élément de formulaire utilisable.`,
        icon: <FontSizeOutlined />,
        iconColor: "#F39C12",
        version: 1,
        getListField: (containerRef) => {
            const listField = ReactDOM.findDOMNode(containerRef)?.closest(".form-field")?.dataset.field
            if (listField) {
                return JSON.parse(listField)
            }
            return null
        },
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },

                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du Champ`,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },
                    placeholder: {
                        type: 'string',
                        uniforms: {
                            label: t`Sous-Étiquette`,
                            placeholder: t`Sous-Étiquette`,
                        }
                    },

                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    },
                    validation: {
                        type: "string",
                        uniforms: {
                            label: t`Type de Validation`,
                            allowedValues: formPlugin.VALIDATION,
                        }
                    },
                }
            },
        },
    }
}
